/* eslint-disable class-methods-use-this */
import { DividaResource } from '@/models/resources';
import { acertoOrdenouDividasRecomendacao } from '@/modules/events/acerto';
import { IOrdenacaoStrategy } from '../interfaces/IOrdenacaoStrategy';
import { TipoOrdenacao } from '../types/TipoOrdenacao';

/**
 * Estratégia de ordenação por ordem de chegada (sem ordenação especial)
 */
export class OrdenacaoPorOrdemChegadaStrategy implements IOrdenacaoStrategy {
  private static eventoDisparado = false;

  ordenar(lote: DividaResource[], tipoOrdenacao: TipoOrdenacao): DividaResource[] {
    if (tipoOrdenacao !== TipoOrdenacao.ORDEM_CHEGADA) {
      throw new Error(`Tipo de ordenação ${tipoOrdenacao} não suportado por esta estratégia`);
    }

    if (lote.length > 0 && !OrdenacaoPorOrdemChegadaStrategy.eventoDisparado) {
      acertoOrdenouDividasRecomendacao('ordem_de_chegada');
      OrdenacaoPorOrdemChegadaStrategy.eventoDisparado = true;
    }

    // Retorna o lote sem alteração (ordem de chegada)
    return lote;
  }

  /**
   * Reseta a flag de evento disparado (útil para testes ou quando a ordem é limpa)
   */
  static resetEventoDisparado(): void {
    OrdenacaoPorOrdemChegadaStrategy.eventoDisparado = false;
  }
}
